import React from 'react';
import { useLocationStore } from '../../state/storeLocation';
import Dropdown from '../ui/Dropdown';
import { useMonth } from '../../hooks/useMonth';
import { usePostControlFromUI } from '../../hooks/usePostControlFromUI';
import { useConditional } from '../../state/storeConditional ';

type Location = {
  name?: string | undefined;
  method?: string | undefined;
  id?: string | undefined;
  country?: string | undefined;
  city?: string | undefined;
  lat?: string | undefined;
  lng?: string | undefined;
};

const PrayerSettingDropDown = () => {
  const month = useLocationStore((state) => state.month);
  const oaac = useLocationStore((state) => state.oaac);
  const mncm = useLocationStore((state) => state.mncm);
  const hlm = useLocationStore((state) => state.hlm);
  const mfc = useLocationStore((state) => state.mfc);
  const asrCal = useLocationStore((state) => state.asrCal);
  const mcMode = useLocationStore((state) => state.mcMode);
  const highLittude = useLocationStore((state) => state.highLittude);
  const { customLocationData, customLocationSelected, cl_selected } = useLocationStore((state) => state);
  const { updateTheMonthOnly } = usePostControlFromUI();
  const methodsForCal = useLocationStore((state) => state.methodsForCal);
  const { MonthList } = useMonth();
  const [asr, setAsr] = React.useState(oaac);
  const [mnc, setMncm] = React.useState(mncm);
  const [mf, setMfc] = React.useState(mfc);
  const [hl, setHlm] = React.useState(hlm);
  const [CustomLocationS, setCustomLocationS] = React.useState<Location>(customLocationSelected);
  const [months, setMonth] = React.useState(month);
  const [isUpdating, setIsUpdating] = React.useState(false); // Loading state
	const {isReadyGenerator } = useConditional();

  React.useEffect(() => {
    cl_selected(CustomLocationS);
  }, [CustomLocationS]);

  React.useEffect(() => {
    setAsr(oaac);
    setHlm(hlm);
    setMfc(mfc);
    setMncm(mncm);
    setMonth(month);
  }, [oaac, hlm, mfc, mncm, month]);

  React.useEffect(() => {
    setCustomLocationS(customLocationSelected);
  }, [customLocationSelected]);

  const updateHandler = async () => {
	if(isReadyGenerator){
		setIsUpdating(true); // Start loading

	}
    try {
        await updateTheMonthOnly(month); // Now properly awaited
    } catch (error) {
        console.error('Failed to update month:', error);
    } finally {
		setTimeout(() => {
			setIsUpdating(false);
		}
		, 2000);
         // Stop loading
    }
};


  return (
    <div className="">
      <div className="flex items-center justify-between">
        <h2 className="text-lg text-green-600 py-2">Prayer Settings</h2>
        <button
          onClick={updateHandler}
          className="bg-white text-green-600 px-4 py-2 rounded-md flex items-center gap-2 border border-green-600 hover:bg-green-50 transition-colors"
          disabled={isUpdating} // Disable button while loading
        >
          {isUpdating ? (
            <>
              <svg
                className="animate-spin h-5 w-5 text-green-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Updating...
            </>
          ) : (
            'Update Month'
          )}
        </button>
      </div>
      <div className="grid gap-1 grid-cols-2 grid-rows-3">
        <Dropdown
          label={'Month'}
          meta={'month'}
          options={{value:MonthList}}
          value={months}
          onChange={(value) => setMonth(value)}
        />
        <Dropdown
          label={'Location, City'}
          meta={'location'}
          options={customLocationData}
          value={CustomLocationS}
          onChange={(value) => setCustomLocationS(value)}
        />
        <Dropdown
          label={'Higher Latitude Adjustment Method'}
          meta={'hlm_selected'}
          options={highLittude}
          value={hl}
          onChange={(value) => setHlm(value)}
        />
        <Dropdown
          label={'Method (Learn more about calculation)'}
          meta={'mfc_selected'}
          options={methodsForCal}
          value={mf}
          onChange={(value) => setMfc(value)}
        />
        <Dropdown
          label={'Only affects Asr calculation'}
          meta={'oaac_selected'}
          options={asrCal}
          value={asr}
          onChange={(value) => setAsr(value)}
        />
        <Dropdown
          label={'Midnight Calculation Mode'}
          meta={'mncm_selected'}
          options={mcMode}
          value={mnc}
          onChange={(value) => setMncm(value)}
        />
      </div>
    </div>
  );
};

export default PrayerSettingDropDown;